export default "__VITE_ASSET__90386424__"